import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { TranslatePipe } from '@ngx-translate/core';

import { MpsLoaderService } from '../../services/mps-loader.service';

@Component({
  selector: 'mps-loader',
  templateUrl: './mps-loader.component.html',
  styleUrl: './mps-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatProgressSpinner, AsyncPipe, TranslatePipe],
})
export class MpsLoaderComponent {
  loader = inject(MpsLoaderService);
}
